<template>
  <div class="space-tree">
    <div v-if="checkShow" style="margin: 0 0 11px 10px;">
      <el-checkbox v-model="checked" style="display: inline" @change="changeCheckbox">
        显示所有
      </el-checkbox>
    </div>

    <tree :nodes="nodes" :setting="setting"
          ref='ztreeDom'
          highlight-current
          @onClick="ztreeOnClick"
          @onCreated="handleCreated"/>
  </div>
</template>

<script>
import tree from "vue-giant-tree";
import {getSpaceTreeDataSystemType} from "@/network/power-wiring-diagram";
import {getOrgList} from "@/network/organization";

export default {
  name: "SpaceTreeShow",
  components: {tree},
  props: {
    checkShow: null,
    isOpen: {},
    spaceId: null,
    tree: {
      type: String,
      default: "space"
    },
    systemType: {
      type: String,
      default: "1"
    },
    setting: {
      type: Object,
      default: () => {
        return {
          view: {
            showIcon: false
          },
          data: {
            key: {
              name: 'title'
            },
            simpleData: {
              enable: true,
              pIdKey: 'parentId'
            }
          },
        }
      }
    }
  },
  data() {
    return {
      openState: true,
      nodes: [],
      iniTableData: [],
      //ztree对象
      ztreeObj: null,
      checked: false,
      lastTimeId: null
    };
  },
  mounted() {
    this.ztree();
  },
  watch: {
    spaceId() {
      this.getSelectNode();
    }
  },
  methods: {
    changName(name) {
      if (!name) {
        this.nodes = this.iniTableData
        return
      }
      let arr = JSON.parse(JSON.stringify(this.iniTableData))
      let newA = []
      arr.forEach((item,ind) => {
        newA[ind] = item
        if(newA[ind].title.indexOf(name) == '-1'){
          newA[ind].children = item.children?item.children.filter(val => val.title.indexOf(name) != '-1'): []
        }else{
          newA[ind].children = item.children
        }
      })
      for(let i=newA.length; i--; i>0 ) {
        if(!newA[i].children || newA[i].children.length == 0) {
          if(newA[i].title.indexOf(name) == '-1'){
            newA.splice(i,1)
          }
        }
      }
      this.nodes = newA
    },
    ztree() {
      if (this.tree === 'space') {
        this.getSpaceTreeDataSystemType();
      } else {
        this.getOrgList();
      }
    },
    getSpaceTreeDataSystemType() {
      getSpaceTreeDataSystemType(this.systemType).then(res => {
        this.nodes = res.data;
        this.iniTableData=this.nodes
      })
    },
    getOrgList() {
      getOrgList().then(res => {
        this.nodes = res.data;
        this.iniTableData=this.nodes
      })
    },
    ztreeOnClick(evt, treeId, treeNode) {
      // 阻止事件冒泡
      if (evt) {
        evt.stopPropagation();
      }
      
      if (this.checked) {
        this.checked = false;
      }
      
      // 确保只发送一次事件
      console.log('树节点点击，发送 spaceChoose 事件:', treeNode.id);
      this.$emit('spaceChoose', treeNode, false);
    },
    handleCreated(ztreeObj) {
      let that=this;
      this.ztreeObj = ztreeObj;
      // 设置节点全部展开
      if (this.isOpen !== undefined) {
        this.openState = this.isOpen;
      } else {
        this.getSelectNode(that);
      }
      ztreeObj.expandAll(this.openState);
    },
    getSelectNode(that) {
      // 使用当前实例如果 that 未定义
      that = that || this;
      
      let firstTree;
      // 安全地检查 spaceId
      if (that && that.spaceId) {
        firstTree = this.selectedSpace(that.ztreeObj.getNodes());
      } else {
        // 默认选中第一个子空间
        firstTree = that.firstChildren(that.ztreeObj.getNodes());
      }
      
      // 安全地检查 firstTree 和 ztreeObj
      if (firstTree && that.ztreeObj) {
        that.ztreeObj.selectNode(firstTree);
        if (firstTree !== undefined) {
          that.$emit('spaceChoose', firstTree, true);
        }
      }
    },
    firstChildren(firstTree) {
      if (firstTree !== undefined) {
        for (let item of firstTree) {
          if (item !== undefined && item.children !== undefined && item.children.length > 0) {
            let children = this.firstChildren(item.children);
            if (children !== undefined && children.type !== 1) {
              return children;
            }
          } else {
            // 返回item
            if (item !== undefined && item.type !== 1) {
              return item;
            }
          }
        }
      }
    },
    selectedSpace(list) {
      if (!list || !Array.isArray(list)) return;
      
      for (let item of list) {
        // 返回item
        if (item !== undefined && item.id === this.spaceId) {
          return item;
        } else {
          if (item !== undefined && item.children !== undefined && item.children.length > 0) {
            let children = this.selectedSpace(item.children);
            if (children !== undefined && children.id === this.spaceId) {
              return children;
            }
          }
        }
      }
    },
    changeCheckbox() {
      if (this.checked) {
        let node = this.ztreeObj.getSelectedNodes()
        if (node.length > 0) {
          //记录上一次选中节点
          this.lastTimeId = node[0].id;
        }
        //显示全部设备
        //1.取消节点选择
        this.ztreeObj.cancelSelectedNode();
        //2.查询所有设备
        this.$emit('getAllDevice', null, false)
      } else {
        if (this.lastTimeId) {
          let node = this.ztreeObj.getNodeByParam('id', this.lastTimeId);
          this.ztreeObj.selectNode(node)
          this.$emit('spaceChoose', node, false)
          this.lastTimeId = null;
        }
      }
    },
  }
}
</script>

<style>
.space-tree {
  overflow: auto;
  max-height: 70vh;
}

/*文字颜色*/
.space-tree .ztree span, .button:before {
  color: #FFFFFF;
  border-color: transparent transparent transparent #ffffff !important;
}
</style>
<style scoped>
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: rgba(0, 0, 0, 0.1);
  border-color: rgb(7, 230, 248);

}

::v-deep .el-checkbox__label {
  display: inline !important;
  padding-left: 5px;
  color: #07e6f8 !important;
}

::v-deep .el-checkbox__inner::after {
  border: 1px solid rgb(7, 230, 248);
  border-left: 0;
  border-top: 0;
}

::v-deep .el-checkbox__inner {
  margin-top: -2px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.1);
  border: 1px solid rgb(7, 230, 248);
}
</style>
